module.exports = __webpack_public_path__ + "34ff34f97913c0716e1f9e6576a17342.pdf";